import axios from 'axios';
import router from '../router';
import store from '@/store';
import Qs from 'qs';
import { Message } from 'element-ui';
import { IS_MOCK, MockURL } from '_libs/host';
import { typeOf } from 'tools';
// 创建axios实例
import { showLoading, hideLoading } from '@/util/bridge'
const service = axios.create({
    baseURL: IS_MOCK ? MockURL : process.env.BASE_API, // api的base_url
    timeout: 120000,                  // 请求超时时间120秒，和服务端保持一致
    withCredentials: true,
    // transformRequest: [function (data) {
    //     // Do whatever you want to transform the data
    //     let ret = ''
    //     for (let it in data) {
    //         ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    //     }
    //     return ret
    // }],
});

// request拦截器
service.interceptors.request.use(config => {
    if (config.brokerParams && config.brokerParams.loadingParams) {
        config.brokerParams.loadingParams !== 'no-loading' && showLoading(config.brokerParams.loadingParams)
    } else {
        // showLoading()
    }
    // Do something before request is sent
    // if (store.getters.token) {
    //     config.headers['X-Token'] = store.getters.token; // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    // }
    return config
}, error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
})

// respone拦截器
service.interceptors.response.use(
    response => {
        if (response.config && response.config.brokerParams && response.config.brokerParams.loadingParams) {
            response.config.brokerParams.loadingParams !== 'no-loading' && hideLoading()
        } else {
            // hideLoading()
        }
        // console.log('response', response)
        if (response.data && response.data.resCode === '000001' || response.data && response.data.resCode === '000011') {
            return response.data;
        } else if (response.data && response.data.code == 401) {
            return Promise.reject(response.data)
        } else if (response.data && response.data.code == 400) {
          return Promise.reject(response.data);
        } else if (typeOf(response.data)==='array') { //特殊接口返回，数据只有数组
            return response.data;
        } else if (response.data && response.data.code == 200) {
            return response.data;
        } else {
            if (response.request.responseURL.indexOf('.json') > 0 || response.request.responseURL.indexOf('/api/getAreaCode') > 0) {
                return response.data;
            }
            if (response.data.resCode === '001011') {
                if (response.request.responseURL.indexOf('getUserInfo') === -1) {
                    store.commit('SET_LOGIN_MODAL', true)
                }
            } else {
                if (response.status != 200 || response.data.resCode === '006004') {
                  Message({
                    message: response.data.info,
                    type: 'error',
                  })
                } else if(response.status == 200 && response.request.responseURL.indexOf('/api/getGroupProfessionByProductId') > 0){
                    return response.data;
                }
            }
            return Promise.reject(response.data);
        }
    },

    error => {
        hideLoading()
        // if(error.response && error.response.status === 401) { // 没有登录，跳转到登录页面
        //     router.push('/login');
        //     return
        // } else if (error.response && error.response.status === 403) { // 登录成功，但是登录账号没有该系统的权限
        //     router.push('/401');
        //     return;
        // } else {
        //     console.log(error.response)
        // }
        let msg = error.info || '系统繁忙，请稍后重试';
        Message({
            message: msg,
            type: 'error',
        })
        return Promise.reject(error);
    }
)

export default service;



// WEBPACK FOOTER //
// ./src/api/fetch.js